import React, { useState, useEffect } from "react";
import TabList from "../../Components/TabList";
import { Grid, Box, Container, Typography } from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

//Components
import IndexHeader from "../../Components/IndexHeader";
import Footer from '../../Components/Footer';

const Faqs = () => {
  const [expanded, setExpanded] = useState('Panel 1');
  const faqList = [
    {'serial':'Panel 1', 'title':'What is an expense tracker app?', 'answer':'An expense tracker app is a digital tool designed to help individuals and businesses manage and monitor their expenses. It allows users to record and categorize their expenses, track spending patterns, set budgets, and generate reports to gain better control over their finances.'},
    {'serial':'Panel 2', 'title':'Why should I use an expense tracker app?','answer':'Expense tracker apps provide several benefits, including: <ul><li>Organizing and categorizing expenses for better financial visibility.</li> <li>Tracking spending habits and identifying areas for potential savings.</li> <li>Setting and monitoring budgets to achieve financial goals.</li> <li>Generating reports for tax purposes or expense reimbursements.</li> <li>Accessing financial information anytime, anywhere, from a mobile device.</li></ul>'},
    {'serial':'Panel 3', 'title':'Is my financial information safe in an expense tracker app?', 'answer':'All security measures have been taken to protect the user information and their related data. It include data encryption, secure login methods, and compliance with data protection regulations. You can review our privacy policy to understand how your data is handled.'},
    {'serial':'Panel 4', 'title':'Can I customize expense categories in the app?','answer':'Yes, You can create your own expense/income categories as per your actual need. You can typically add, edit categories to create a personalized expense structure. I helps you alot in better organization and analysis of your spending habits.'},
    {'serial':'Panel 5', 'title':'Is the app available on multiple devices?','answer':'Yes, All your data is stored somewhere in cloud, So you can use mobile, tablet or laptop at the same time to use this application'},
    {'serial':'Panel 6', 'title':'Is this app totally free to use?','answer':'Since the application is in Beta(few pro features are in development), So using application is totally free for users now. Once it will go live then user will required to pay for pro features and basic features will be available to user for free.'},
    {'serial':'Panel 7', 'title':'What happens if I switch devices or get a new phone?','answer':'No worries, There is no dependency on any device, As all your data is stored on cloud.'},
    {'serial':'Panel 8', 'title':'Can I use an expense tracker app for both personal and business expenses?','answer':'Yes, This app is designed to handle both personal and business expenses. It allow you to create multiple expense categories and separate your personal and business transactions easily.'},
  ];

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[]);
  return (
    <>
      <IndexHeader />
      <Typography style={{display: 'flex', justifyContent: 'center', marginTop:'70px', fontWeight:'bold'}} variant="h4" component="h2">
        Frequently Asked Questions
      </Typography>

      <div>
      <Grid container spacing={4}>
      <Container maxWidth="lg" className="header-container-1">

      <Grid className="privacy-content" item xs={12} style={{ marginTop: "100px", marginBottom:"100px", marginLeft:'30px' }}>
        {faqList.map((data, index) => (
          <Accordion className="faqs-accordian" expanded={expanded === data.serial} onChange={handleChange(data.serial)}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className="title-accordian"
            >
              <Typography>{data.title}</Typography>
            </AccordionSummary>
            <AccordionDetails className="accodian-content">
              <Typography>
              <div className="content" dangerouslySetInnerHTML={{__html: data.answer}}></div>
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Grid>
      </Container>
      </Grid>      
    </div>

      <Footer/>
    </>
  );
};

export default Faqs;
